import { render, staticRenderFns } from "./OfferCardTableMetrics.vue?vue&type=template&id=85b0d394&scoped=true&"
import script from "./OfferCardTableMetrics.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OfferCardTableMetrics.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./OfferCardTableMetrics.vue?vue&type=style&index=0&id=85b0d394&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b0d394",
  null
  
)

export default component.exports